import React from "react";
import {
  Input,
  Button,
  MaskedInput,
} from "@dreambigger/design-system/src/components";
import { Form } from "antd";
import { RefObject } from "react";

export type InlineButtonInputProps = {
  form: any;
  loginMode: "email" | "sms";
  keyByLoginMode: string;
  formattedCred: any;
  loginPlaceholder?: string;
  submitButtonText?: string;
  emailInputRef: RefObject<any>;
  phoneInputRef: RefObject<any>;
  onFinish: (values: any) => void;
  isAdminMode?: boolean;
  buttonColor?: string;
  buttonTextColor?: string;
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
  innerClassName?: string;
  innerStyle?: React.CSSProperties;
};

export default function InlineButtonInput({
  form,
  loginMode,
  keyByLoginMode,
  formattedCred,
  loginPlaceholder,
  submitButtonText,
  emailInputRef,
  phoneInputRef,
  onFinish,
  isAdminMode = false,
  wrapperClassName = "",
  wrapperStyle = {},
  innerClassName = "",
  innerStyle = {},
}: InlineButtonInputProps) {
  return (
    <Form
      form={form}
      initialValues={{ [keyByLoginMode]: formattedCred }}
      onFinish={onFinish}
      className={`relative ${wrapperClassName}`}
      style={{
        display: "inline-block",
        width: "100%",
        maxWidth: "500px",
        ...wrapperStyle,
      }}
    >
      <div className="relative">
        <Form.Item name={keyByLoginMode} className="mb-0">
          {loginMode === "email" ? (
            <Input
              placeholder={loginPlaceholder || "Enter your email"}
              type="email"
              ref={emailInputRef}
              className={`${
                isAdminMode && "disabled notAllowed"
              } ${innerClassName}`}
              style={{
                height: "38px",
                borderRadius: "19px",
                paddingLeft: "18px",
                paddingRight: "120px",
                border: "none",
                backgroundColor: "white",
                width: "100%",
                ...innerStyle,
              }}
              readOnly={isAdminMode}
              required
            />
          ) : (
            <MaskedInput
              placeholder={loginPlaceholder || "Enter your phone number"}
              mask="(000) 000-0000"
              name="phone"
              ref={phoneInputRef}
              className={`${
                isAdminMode && "disabled notAllowed"
              } ${innerClassName}`}
              style={{
                height: "38px",
                borderRadius: "19px",
                paddingLeft: "18px",
                paddingRight: "120px",
                border: "none",
                backgroundColor: "white",
                width: "100%",
                ...innerStyle,
              }}
              readOnly={isAdminMode}
            />
          )}
        </Form.Item>

        <Form.Item className="absolute mb-0" style={{ right: "0", top: "0" }}>
          <Button
            type="primary"
            htmlType="submit"
            className={`${innerClassName} subtleGrow`}
            style={{
              height: "38px",
              borderRadius: "19px",
              paddingLeft: "28px",
              paddingRight: "28px",
              boxShadow: "none",
            }}
          >
            {submitButtonText || "Submit"}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
}
